
import React from "react";
import { useAuthForm } from "@/context/auth-form";
import AuthCard from "@/components/auth/AuthCard";
import AuthFormContainer from "@/components/auth/AuthFormContainer";
import { useAuthHandler } from "@/hooks/useAuthHandler";
import { useAuth } from "@/context/auth";

const AuthContent = () => {
  const {
    email,
    password,
    setTab,
    setMode,
  } = useAuthForm();
  
  const { user } = useAuth();
  
  const {
    handleLogin: authHandleLogin,
    handleSignup: authHandleSignup,
    handleGoogleLogin
  } = useAuthHandler();

  const handleLogin = async (e: React.FormEvent) => {
    await authHandleLogin(e, email, password);
  };

  const handleSignup = async (e: React.FormEvent) => {
    await authHandleSignup(e, email, password, setTab, setMode);
  };

  return (
    <AuthCard>
      <AuthFormContainer
        handleLogin={handleLogin}
        handleSignup={handleSignup}
        handleGoogleLogin={handleGoogleLogin}
      />
    </AuthCard>
  );
};

export default AuthContent;
